import { PageHeader } from "components";
import { NextPage } from "next";
import {
  CareerHeaderSection,
  JobsListSection,
  NewsletterSection,
} from "sections";
import { IJobsV3Fields, INewsletterSectionFields } from "types";
import { getContentfulEntries } from "../../utils/contentful-api";

const Career: NextPage<{
  newsletter: INewsletterSectionFields[];
  jobs: IJobsV3Fields[];
}> = ({ newsletter, jobs }) => {
  return (
    <div>
      <PageHeader title="Career" />
      <CareerHeaderSection />
      <JobsListSection jobs={jobs} />
      <NewsletterSection newsletterSection={newsletter} />
    </div>
  );
};

export default Career;

export async function getServerSideProps() {
  const newsletter = await getContentfulEntries<INewsletterSectionFields>(
    "newsletterSection"
  );

  const jobs = await getContentfulEntries<IJobsV3Fields>("jobsV3");

  return {
    props: {
      newsletter,
      jobs,
    },
  };
}
